exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".navigation-drawer{position:fixed}.menu__content{background-color:#595959}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/NavBar.vue"],"names":[],"mappings":"AACA,mBACE,cAAgB,CACjB,AACD,eACE,wBAAkC,CACnC","file":"NavBar.vue","sourcesContent":["\n.navigation-drawer {\n  position: fixed;\n}\n.menu__content {\n  background-color: rgb(89, 89, 89);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c3d85f2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Components/NavBar.vue
// module id = 1154
// module chunks = 2 9